import { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { whatsappLink } from '@/mocks/gymInfo';

export default function CTASection() {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const items = el.querySelectorAll('.reveal-item');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement;
            const index = Array.from(items).indexOf(target);
            target.style.transitionDelay = `${index * 100}ms`;
            target.classList.add('reveal-visible');
            observer.unobserve(target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );
    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="reveal-item reveal-left relative min-h-[400px] md:min-h-[500px]">
          <img
            src="https://storage.readdy-site.link/project_files/1a1c8768-7964-48a6-af85-b4ce5b39e023/d4150332-d1f5-4178-9652-afed22691ab9_TopGym00020.jpg?v=eec3a70e5abad58560d005f89652f073"
            alt="Top Gym Cumbuco"
            loading="lazy"
            fetchPriority="low"
            width="800"
            height="600"
            decoding="async"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-foreground-950/60"></div>
          <div className="relative z-10 flex flex-col justify-between h-full p-6 md:p-10">
            <span className="reveal-item reveal font-body text-sm text-background-400 tracking-widest uppercase">
              {t('home.cta.label')}
            </span>
            <h2 className="reveal-item reveal font-heading text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight">
              {t('home.cta.title')}
            </h2>
          </div>
        </div>

        <div className="reveal-item reveal-right bg-background-50 flex flex-col items-center justify-center p-6 md:p-10 text-center">
          <h3 className="reveal-item reveal font-heading text-3xl md:text-4xl text-foreground-950">
            {t('cta.heading')}
          </h3>
          <p className="reveal-item reveal font-body text-base text-foreground-600 mt-4 max-w-md leading-relaxed">
            {t('home.cta.text')}
          </p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="reveal-item reveal btn-hover inline-flex items-center gap-2 bg-foreground-950 hover:bg-foreground-900 text-background-50 font-body text-sm font-semibold px-6 py-3.5 rounded-full whitespace-nowrap"
          >
            {t('home.cta.button')}
            <i className="ri-arrow-right-line text-base btn-icon-move"></i>
          </a>
        </div>
      </div>
    </section>
  );
}